import { TableBodyProps } from "../../types";
import parseArray from "utils/parseArray";
import { KEYS_TO_BE_REMOVED } from "../..";
import { Cell } from "@tanstack/react-table";
import { Column, RowsActions } from "../index";
import { useNavigate } from "react-router-dom";
import "../../../Table/Observations.scss"

export const TableBody = ({
  table,
  columnVisibility,
  getReportsProfileActions,
  flexRender,
}: TableBodyProps) => {
  // Comprehensive error handling for table data
  if (!table || typeof table.getRowModel !== 'function') {
    return (
      <tbody>
        <tr>
          <td colSpan={100} className="text-center py-8">
            <p className="text-gray-500">Table not initialized...</p>
          </td>
        </tr>
      </tbody>
    );
  }

  try {
    const rowModel = table.getRowModel();
    if (!rowModel || !rowModel.rows || !Array.isArray(rowModel.rows)) {
      return (
        <tbody>
          <tr>
            <td colSpan={100} className="text-center py-8">
              <p className="text-gray-500">Loading table data...</p>
            </td>
          </tr>
        </tbody>
      );
    }

    const rows = rowModel.rows;
    
    if (rows.length === 0) {
      return (
        <tbody>
          <tr>
            <td colSpan={100} className="text-center py-8">
              <p className="text-gray-500">No data available</p>
            </td>
          </tr>
        </tbody>
      );
    }

    return (
      <tbody>
        {rows.map((row: any, index: number) => {
          try {
            const visibleCells = row?.getVisibleCells?.() || [];
            if (!Array.isArray(visibleCells)) {
              return (
                <tr key={index} className="Close w-full item_data" style={{ height: "66px" }}>
                  <td colSpan={100} className="text-center py-4">
                    <p className="text-gray-500">Loading row data...</p>
                  </td>
                </tr>
              );
            }

            return (
              <tr
                key={index}
                className="Close w-full item_data"
                style={{ height: "66px" }}
              >
                {parseArray(visibleCells, KEYS_TO_BE_REMOVED)?.map(
                  (cell: Cell<any, any>) => (
                    <Column
                      key={cell.id}
                      hoverEffect="item_hover_effect"
                      flexRender={flexRender}
                      cell={cell}
                      columnVisibility={columnVisibility}
                    />
                  )
                )}
                {/* <td className="whitespace-nowrap sticky right-0 dark:bg-bgtetriaryz-10 bg-bgWhite item_hover_effect dark:bg-secondaryLight">
                  <RowsActions
                    row={row}
                    getReportsProfileActions={getReportsProfileActions}
                  />
                </td> */}
              </tr>
            );
          } catch (rowError) {
            console.error('TableBody row error:', rowError);
            return (
              <tr key={index} className="Close w-full item_data" style={{ height: "66px" }}>
                <td colSpan={100} className="text-center py-4">
                  <p className="text-red-500">Error loading row</p>
                </td>
              </tr>
            );
          }
        })}
      </tbody>
    );
  } catch (error) {
    console.error('TableBody error:', error);
    return (
      <tbody>
        <tr>
          <td colSpan={100} className="text-center py-8">
            <p className="text-red-500">Error loading table data</p>
          </td>
        </tr>
      </tbody>
    );
  }
};
